<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    :minimalize="minimalize"
  >
    <BaseInput
      :label="t['dialogs-add_edit-labels']['nazvanie']"
      v-model="name"
      prepend-inner-icon="mdi-folder-open"
      :rules="['required', 'max100']"
    />
  </TemplateModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'WorkDocsSchemeClassModal',
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    create: Boolean,
    minimalize: Boolean,
  },
  data: () => ({
    name: ''
  }),
  computed: {
    ...mapGetters('workDocsSchemeClass', ['workDocsSchemeClassShow']),
    t() {
      return this.localStorage.translations.pages['setting-scheme_class']
    },
    text() {
      return {
        button: {
          open: this.minimalize
            ? this.localStorage.translations.pages['common']['buttons']['dobavit']
            : this.t['dialogs-add_edit-buttons']['dobavit-soderzhanie-chertezha'],
        },
        title: {
          create: this.t['dialogs-add_edit']['dobavlenie-soderzhaniya-chertezha'],
          edit: this.t['dialogs-add_edit']['redaktirovanie-soderzhanie-chertezha'],
        },
      }
    },
  },
  methods: {
    ...mapActions('workDocsSchemeClass', [
      'onWorkDocsSchemeClassShow',
      'onWorkDocsSchemeClassCreate',
      'onWorkDocsSchemeClassGrid',
      'onWorkDocsSchemeClassUpdate',
      'onWorkDocsSchemeClassAll',
    ]),
    async onOpen() {
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
      if (this.create)
        this.name = ''
      else {
        await this.onWorkDocsSchemeClassShow(this.id)
          .then(() => {
            this.name = this.workDocsSchemeClassShow.name
          })
      }
    },
    onSave() {
      if (this.create) {
        let data = {
          name: this.name,
        }
        this.onWorkDocsSchemeClassCreate(data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'uspeshno-dobavlen'
                      ],
                  IsError: false,
                },

                { root: true },
              )
              if (this.SettingWorkDocsSchemeClassPage) {
                this.onWorkDocsSchemeClassGrid({
                  limit: this.$route.query.limit,
                  page: this.$route.query.page,
                })
              } else {
                this.onWorkDocsSchemeClassAll()
              }

              this.closeModal()
            }
          })
          .catch((err) => {
            if (err.response.data.name[0]) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'name_is_already_in_use'
                      ],
                  IsError: true,
                },
                { root: true },
              )
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      } else {
        let data = {
          id: this.workDocsSchemeClassShow.id,
          name: this.name,
        }
        this.onWorkDocsSchemeClassUpdate(data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'izmeneniya-uspeshno-sohraneny'
                      ],
                  IsError: false,
                },

                { root: true },
              )
              this.onWorkDocsSchemeClassGrid({
                limit: this.$route.query.limit,
                page: this.$route.query.page,
              })
              this.closeModal()
            }
          })
          .catch((err) => {
            if (err.response.data.name[0]) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'name_is_already_in_use'
                      ],
                  IsError: true,
                },
                { root: true },
              )
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      }
    },
  },
}
</script>
